<template>
	<div id="app">
		<HeaderComponent />
		<div class="main-content">
			<router-view />
		</div>
		<FooterComponent />
	</div>
</template>

<script>
	import HeaderComponent from './components/Header.vue';
	import FooterComponent from './components/Footer.vue';

	export default {
		name: 'App',
		components: {
			HeaderComponent,
			FooterComponent
		}
	};
</script>

<style>
	/* 给内容区域一个 top margin，等于 header 高度 */
	.main-content {
		margin-top: 80px;

		@media (max-width: 768px) {
			margin-top: 70px;
		}
	}
</style>